import React from "react";
import { Link } from "react-router-dom";
import { Mail, Twitter, Linkedin, Github } from "lucide-react";
import Brand from "./Brand";

export default function Footer() {
  return (
    <footer data-testid="public-footer" className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-6 gap-8">
        <div className="col-span-2">
          <div className="mb-4">
            <Brand to="/" tone="dark" size="lg" testId="footer-brand" />
          </div>
          <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
            An interactive writing improvement platform that strengthens grammar, structure, clarity, and analytical thinking through guided practice.
          </p>
          <a href="mailto:info@writersspark.net" data-testid="footer-email"
            className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-indigo-300 hover:text-indigo-200">
            <Mail size={14}/> info@writersspark.net
          </a>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest font-bold text-slate-500 mb-3">Platform</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/app/practice" className="hover:text-white">Writing Practice</Link></li>
            <li><Link to="/app/grammar" className="hover:text-white">Grammar Lab</Link></li>
            <li><Link to="/app/essay" className="hover:text-white">Essay Coach</Link></li>
            <li><Link to="/app/sat-ap" className="hover:text-white">SAT/AP Prep</Link></li>
            <li><Link to="/blog" className="hover:text-white" data-testid="footer-blog">Blog</Link></li>
            <li><Link to="/faq" className="hover:text-white" data-testid="footer-faq">FAQ</Link></li>
          </ul>
        </div>
        <div className="col-span-2">
          <div className="text-xs uppercase tracking-widest font-bold text-slate-500 mb-3">Writing resources</div>
          <ul className="space-y-2 text-sm grid grid-cols-1 sm:grid-cols-2 gap-x-4">
            <li><Link to="/essay-writing-help" className="hover:text-white">Essay writing help</Link></li>
            <li><Link to="/argumentative-writing-support" className="hover:text-white">Argumentative writing</Link></li>
            <li><Link to="/narrative-writing-support" className="hover:text-white">Narrative writing</Link></li>
            <li><Link to="/constructed-response-strategies" className="hover:text-white">Constructed response</Link></li>
            <li><Link to="/thesis-writing-help" className="hover:text-white">Thesis writing help</Link></li>
            <li><Link to="/paragraph-organization-practice" className="hover:text-white">Paragraph organization</Link></li>
            <li><Link to="/writing-revision-strategies" className="hover:text-white">Writing revision</Link></li>
            <li><Link to="/student-writing-improvement" className="hover:text-white">Student writing growth</Link></li>
            <li><Link to="/ai-writing-feedback-for-students" className="hover:text-white">AI writing feedback</Link></li>
            <li><Link to="/writing-intervention-tools" className="hover:text-white">Writing intervention</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest font-bold text-slate-500 mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-about">About</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Service</Link></li>
          </ul>
          <div className="text-xs uppercase tracking-widest font-bold text-slate-500 mt-6 mb-3">Connect</div>
          <ul className="flex gap-3">
            <li><a href="https://twitter.com" target="_blank" rel="noreferrer" data-testid="social-twitter" aria-label="Twitter"
              className="w-9 h-9 rounded-full bg-slate-800 grid place-items-center hover:bg-indigo-500 hover:text-white transition"><Twitter size={16}/></a></li>
            <li><a href="https://linkedin.com" target="_blank" rel="noreferrer" data-testid="social-linkedin" aria-label="LinkedIn"
              className="w-9 h-9 rounded-full bg-slate-800 grid place-items-center hover:bg-indigo-500 hover:text-white transition"><Linkedin size={16}/></a></li>
            <li><a href="https://github.com" target="_blank" rel="noreferrer" data-testid="social-github" aria-label="GitHub"
              className="w-9 h-9 rounded-full bg-slate-800 grid place-items-center hover:bg-indigo-500 hover:text-white transition"><Github size={16}/></a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-500">
          <div>© 2026 WriterSpark. All rights reserved.</div>
          <div>Built for students, parents, and teachers who care about real writing skill.</div>
        </div>
      </div>
    </footer>
  );
}
